/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Has_CaptionsInputs */



/**
* | output |
* | --- |
* | "Has captions" |
*
* @param {Embed_Captions_Local_Has_CaptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_has_captions = /** @type {((inputs?: Embed_Captions_Local_Has_CaptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Has_CaptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contient des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hat Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ha sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Содержит субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiene subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("有字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕付き")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इसमें कैप्शन हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Possui legendas")
	return /** @type {LocalizedString} */ ("Has captions")
});